<template>
  <div class="offset-sm-1 col-sm-9 col-10 offset-1 change-pwd">
    <form @submit.prevent="changePassword">
      <Alert type="danger" :messages="this.errors" />
      <Alert type="success" :messages="this.messages" />
      <div class="custom-form-block">
        <div class="form-group row">
          <label class="col-md-3 col-form-label">現在のパスワード</label>
          <div class="col-md-8">
            <div class="input-group custom-group">
              <input
                :type="passwordType1"
                v-model="password"
                class="form-control"
                data-vv-delay="0"
                name="current_password"
                v-validate="'required'"
                data-vv-as="現在のパスワード"
              />
              <button
                class="btn-eye"
                type="button"
                @click="showPassword1 = !showPassword1"
              >
                <img
                  :src="
                    require('@/assets/images/' +
                      (showPassword1 ? 'eye.svg' : 'eyeslash.svg'))
                  "
                  alt="toggle password visibility"
                  width="20"
                  height="20"
                />
              </button>
              <FieldError :message="formErrors.first('current_password')" />
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-3 col-form-label">新しいパスワード</label>
          <div class="col-md-8">
            <div class="input-group custom-group">
              <input
                :type="passwordType2"
                v-model="newPassword"
                class="form-control"
                ref="password"
                v-validate="'required|min:8|alhpanum_upper_lower_special'"
                data-vv-as="パスワード"
                name="new_password"
                data-vv-delay="0"
                id="password"
              />
              <button
                class="btn-eye"
                type="button"
                @click="showPassword2 = !showPassword2"
              >
                <img
                  :src="
                    require('@/assets/images/' +
                      (showPassword2 ? 'eye.svg' : 'eyeslash.svg'))
                  "
                  alt="toggle password visibility"
                  width="20"
                  height="20"
                />
              </button>
              <FieldError :message="formErrors.first('new_password')" />
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-3 col-form-label"
            >新しいパスワード（確認用）</label
          >
          <div class="col-md-8">
            <div class="input-group custom-group">
              <input
                :type="passwordType3"
                v-model="confirmPassword"
                class="form-control"
                name="confirm_password"
                v-validate="'confirmed:password'"
                data-vv-as="パスワード"
                id="confirm_password"
                data-vv-delay="0"
              />
              <button
                class="btn-eye"
                type="button"
                @click="showPassword3 = !showPassword3"
              >
                <img
                  :src="
                    require('@/assets/images/' +
                      (showPassword3 ? 'eye.svg' : 'eyeslash.svg'))
                  "
                  alt="toggle password visibility"
                  width="20"
                  height="20"
                />
              </button>
              <FieldError :message="formErrors.first('confirm_password')" />
            </div>
          </div>
        </div>

        <div
          class="btn-toolbar d-flex justify-content-center mt-4"
          role="toolbar"
          aria-label="Toolbar with button groups"
        >
          <router-link to="/applicant" class="btn btn-rounded-plain mr-2"
            >キャンセル</router-link
          >
          <button
            class="btn btn-rounded-md teal-bg white"
            type="submit"
            :disabled="!isFormValid || loading"
          >
            {{ buttonText }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Alert from '@/components/utils/Alert.vue';
import FieldError from '@/components/utils/FieldError.vue';
import Api from '@/config/api';
import ApiService from '@/service/apiService';

export default {
  name: 'PasswordOnly',
  components: { Alert, FieldError },
  data() {
    return {
      password: '',
      newPassword: '',
      confirmPassword: '',
      showPassword1: false,
      showPassword2: false,
      showPassword3: false,
      loading: false,
      errors: [],
      messages: [],
    };
  },
  computed: {
    passwordType1() {
      return this.showPassword1 ? 'text' : 'password';
    },
    passwordType2() {
      return this.showPassword2 ? 'text' : 'password';
    },
    passwordType3() {
      return this.showPassword3 ? 'text' : 'password';
    },
    buttonText() {
      return this.loading ? 'リセット' : '変更する';
    },
    isFormValid() {
      const {
        new_password: newPassword,
        confirm_password: confirm,
        current_password: password,
      } = this.Vfields;
      if (newPassword && password && confirm) {
        return (
          newPassword.changed &&
          password.changed &&
          confirm.changed &&
          this.formErrors.count() === 0
        );
      }
      return false;
    },
    payload() {
      return {
        password: this.password,
        new_password: this.newPassword,
        confirm_password: this.confirmPassword,
      };
    },
  },
  methods: {
    changePassword() {
      if (!this.isFormValid && this.loading) return false;
      this.loading = true;
      this.messages = [];
      this.errors = [];
      return ApiService.post(Api.endpoints.CHANGE_PASSWORD, this.payload)
        .then(() => {
          this.messages.push('パスワードの変更が完了しました');
          this.password = '';
          this.newPassword = '';
          this.confirmPassword = '';
          this.$validator.pause();
          this.$nextTick(() => {
            this.$validator.fields.items.forEach((field) => field.reset());
            this.$validator.fields.items.forEach((field) =>
              this.formErrors.remove(field)
            );
            this.$validator.resume();
          });
        })
        .catch(({ response }) => this.parseErrorResponse(response))
        .then(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style scoped>
.btn-toolbar {
  margin-top: 50px;
  gap: 40px;
}
.custom-form-block label {
  font-size: 14px;
  font-weight: bold;
}

.custom-form-block .form-control {
  border-bottom: 1px solid #999999 !important;
}
.row {
  margin-bottom: 40px !important;
}
.change-pwd {
  margin: 100px auto 55px auto;
}
.custom-group .is-valid {
  background-image: none !important;
}

.custom-group .is-invalid {
  background-image: none !important;
}
</style>
